import { Button, makeStyles } from "@material-ui/core";

import React from "react";
import { useTranslation } from "react-i18next";

const { ModalContentDiv } = require("../SendToSignatureConfirmModal/styles")
const { Header, HeaderCloseButton, ModalTitle, ConcludeButtonContainer } = require("./styles")


const useStyles = makeStyles((theme) => ({
    button: {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.primary.contrastText,
        minWidth: 180,
        minHeight: 50,
        borderRadius: 25,
    },
    buttonOutlined: {
        border: "2px solid",
        fontSize: "1rem",
        fontWeight: "bold",
        color: theme.palette.grey.main,
        textTransform: "capitalize",
        minWidth: 180,
        borderRadius: 25,
        minHeight: 50,
    },
}));

const SureCancelMinuteSignaturesModal = ({ isOpen, setOpen, handleUpdateStatus }) => {
    const classes = useStyles();
    const { t } = useTranslation()

    const handleSureUpdateMinuteStatus = () => {
        handleUpdateStatus(true)
        setOpen(false)
    }

    return (
        <ModalContentDiv>
            <Header>
                <HeaderCloseButton
                    onClick={() => {
                        isOpen(false)
                    }}
                >
                    [X] {t("forms.minutes.signatures.sendToSignCloseModal")}
                </HeaderCloseButton>
            </Header>
            <ModalTitle>
               {t("forms.minutes.updateMinuteStatusModal.cancelMinuteWarn")}
            </ModalTitle>
            <ConcludeButtonContainer>
                <Button
                    className={classes.buttonOutlined}
                    variant="outlined"
                    onClick={() => setOpen(false)}
                >
                    {t("forms.minutes.updateMinuteStatusModal.cancel")}
                </Button>
                <Button
                    className={classes.button}
                    variant="contained"
                    onClick={handleSureUpdateMinuteStatus}
                >
                    {t("forms.minutes.updateMinuteStatusModal.continue")}
                </Button>
            </ConcludeButtonContainer>
        </ModalContentDiv>
    )
}

export default SureCancelMinuteSignaturesModal;